import { render, staticRenderFns } from "./CerrarVenta.vue?vue&type=template&id=20004ea1&"
import script from "./CerrarVenta.vue?vue&type=script&lang=js&"
export * from "./CerrarVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports